import { privateMessageGQLQuery } from '../../graphql/index.js';
export class MessagingClient {
    constructor(client) {
        this.client = client;
    }
    async privateMessage(variables, fields = 'default', accessToken) {
        const result = await this.client.authorizedRequest({
            query: privateMessageGQLQuery(fields),
            variables,
            customToken: accessToken,
        });
        return result.privateMessage;
    }
}
//# sourceMappingURL=messaging.client.js.map